import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ampli } from '../../../../ampli';
import {
  getMachineSearchData,
  IGetMachineSearchParams,
  IUseGetMachineSearchDataReturn,
} from '../../../../api/machine/queries/getMachineSearchData';

export const useGetMachineSearchData = (
  searchParam: IGetMachineSearchParams,
  options?: UseQueryOptions<IUseGetMachineSearchDataReturn, AxiosError>,
) => {
  return useQuery<IUseGetMachineSearchDataReturn, AxiosError>(
    ['machine-search-data', searchParam.q, searchParam.filter],
    async () => {
      const data = await getMachineSearchData(searchParam);
      const searchedMachines = data.hits;

      if (searchParam.q && searchedMachines && searchParam.filter === 'hasPriceStatistics=true') {
        ampli.pvmSearchMarketPriceAccuracyEvaluated({
          search_keyword: searchParam.q,
          search_result: searchedMachines.map((machine) => machine.model),
        });
      }

      return data;
    },
    {
      ...options,
    },
  );
};
